import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  container: {
    width: '260px',
  },
  icon: {
    fontSize: '2rem',
    color: 'red',
  },
  message: {
    textAlign: 'center',
    fontFamily: theme.typography.fontFamily,
    fontSize: '1rem',
    lineHeight: '1.25rem',
    fontWeight: 700,
  },
  subMessage: {
    marginTop: '1rem',
    textAlign: 'center',
    fontFamily: theme.typography.fontFamily,
    fontSize: '0.75rem',
    lineHeight: '1rem',
    fontWeight: 500,
  },
  allowBrowser: {
    textAlign: 'center',
    fontFamily: theme.typography.fontFamily,
    fontSize: '0.75rem',
    lineHeight: '1rem',
    fontWeight: 600,
  },
}));
